module.exports = __webpack_public_path__ + "static/media/stantionBig.5846f3ad.png";